import React from 'react';

import Select from 'components/Select';

import {PaginatorButton} from './components';
import selectArrow from './assets/enlarge.svg';

import './styles.css';

export const arrowRenderer = () => (
  <div className="arrowRenderer">
    <img src={selectArrow} alt="Select arrow" />
  </div>
);

interface PaginationProps {
  elementsCount: number;
  offset: number;
  pageSize: number;
  pageSizes: number[];
}

interface PaginatorProps {
  pagination: PaginationProps;
  onPageChange: ({offset, pageSize}) => void;
  ActionsComponent?: React.ComponentType;
}

class Paginator extends React.Component<PaginatorProps> {
  onNextPage = () => {
    const {pagination} = this.props;
    const pageSize = pagination.pageSize;
    const offset = pagination.offset + pagination.pageSize;

    this.props.onPageChange({offset, pageSize});
  };

  onPrevPage = () => {
    const {pagination} = this.props;
    const pageSize = pagination.pageSize;

    let offset = pagination.offset - pagination.pageSize;
    if (pagination.offset < pagination.pageSize) {
      offset = 0;
    }

    this.props.onPageChange({offset, pageSize});
  };

  onPageSizeChange = newPageSize => {
    const {pagination} = this.props;
    const offset = pagination.offset;

    this.props.onPageChange({offset, pageSize: newPageSize});
  };

  render() {
    const {
      pagination: {offset, pageSize, pageSizes, elementsCount},
      ActionsComponent
    } = this.props;

    const hasPrevious = offset > 0;
    const hasNext = offset + pageSize < elementsCount;

    const PAGE_SIZE_OPTIONS = pageSizes.map(size => ({
      label: size,
      value: size
    }));
    const PAGE_SIZE_OPTION = {
      label: pageSize,
      value: pageSize
    };

    return (
      <div className="Paginator colab-row-space-between colab-centered-v">
        {!ActionsComponent && <div className="Paginator__spacer" />}
        {ActionsComponent && <ActionsComponent />}
        <div className="Paginator__body colab-row-space-between colab-centered-v">
          {hasPrevious && (
            <PaginatorButton
              direction={PaginatorButton.PREVIOUS}
              onClick={this.onPrevPage}
            />
          )}
          {!hasPrevious && <div className="Paginator__spacer" />}

          <p className="Paginator__body__message">
            Showing {offset + 1} to {Math.min(offset + pageSize, elementsCount)}{' '}
            of {elementsCount} results
          </p>
          {hasNext && (
            <PaginatorButton
              direction={PaginatorButton.NEXT}
              onClick={this.onNextPage}
            />
          )}
          {!hasNext && <div className="Paginator__spacer" />}
        </div>
        <div className="Paginator__pageSizes colab-row-space-between colab-centered-v">
          <p className="Paginator__pageSizes__view colab-bold">View</p>
          <Select
            className="Paginator__pageSizes__select"
            onChange={option => this.onPageSizeChange(option.value)}
            value={PAGE_SIZE_OPTION}
            options={PAGE_SIZE_OPTIONS}
            clearable={false}
            arrowRenderer={arrowRenderer}
            menuPosition={Select.TOP}
          />
        </div>
      </div>
    );
  }
}

export default Paginator;
